module.exports = __webpack_public_path__ + "static/qimakansha-44b60d1bdfa38016ca5b900df505224e.jpg";